import React from 'react'
import { Link } from 'gatsby'
import styles from './classes.module.scss'

export default ({ pageTitle, text, lede, classes }) => (
  <div className="wrapper">
    <div
      className={`${
        classes === true ? styles.classesBlockClasses : styles.classesBlock
      }`}
    >
      <div className={`${styles.titleContainer}`}>
        <h2 className={`${styles.classesTitle} heading h1`}>{pageTitle}</h2>
        <p className={` body-text `} style={{ marginBottom: '1rem' }}>
          {text}
        </p>
      </div>
      <div className={`${styles.ledeContainer}`}>
        <p className={`${styles.dingo} heading h4 `}>{lede}</p>
      </div>
    </div>
  </div>
)
